import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import {
	BatchLinkPlugin,
	ClientRetryPlugin,
	type ClientRetryPluginContext,
	SimpleCsrfProtectionLinkPlugin,
} from "@orpc/client/plugins";
import type { RouterClient } from "@orpc/server";

import type { router } from "@/server/api/router";

interface ORPCClientContext extends ClientRetryPluginContext {}

const link = new RPCLink<ORPCClientContext>({
	url: new URL(
		"/rpc",
		typeof window !== "undefined"
			? window.location.href
			: "http://localhost:3000",
	),
	headers: {},
	plugins: [
		new BatchLinkPlugin({
			groups: [
				{
					condition: () => true,
					context: {},
				},
			],
		}),
		new ClientRetryPlugin({
			default: {},
		}),
		new SimpleCsrfProtectionLinkPlugin(),
	],
});

export const orpcClient: RouterClient<typeof router> = createORPCClient(link);
